// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {EmptyStateCommonLayout} from 'app_components/commons/emptyState'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IEmptyStateCommonProps {
  showAddMessage?: boolean
  customMessage?: string | null
}
interface IEmptyStateCommonState {
  showAddMessage?: boolean
  customMessage?: string | null
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class EmptyStateCommon extends Component<IEmptyStateCommonProps, IEmptyStateCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IEmptyStateCommonProps) {
    super(props)
    this.state = {
      showAddMessage: (typeof this.props.showAddMessage === 'undefined') ? true : this.props.showAddMessage,
      customMessage: (typeof this.props.customMessage === 'undefined') ? null : this.props.customMessage,
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <EmptyStateCommonLayout
        {...this.state}
      />
    )
  }
}

export default connect(mapStatesToProps)(EmptyStateCommon)
